
import { Component, Vue } from "vue-property-decorator";
import SidebarItemLink from "../SidebarItemLink.vue";
import { UserModule } from "@/store/modules/user";

@Component({
    name: "SidebarTow",
    components: {
        SidebarItemLink,
    },
})
export default class SidebarAnItem extends Vue {
    private rights: string[] = [];
    private redirectUrl: any = (val: any) => {
        if (val.u) return val.u;
        if (val.l && val.l.length > 0) {
            if (val.l[0] && val.l[0].u) {
                return val.l[0].u;
            }

            return "/";
        }

        return "/";
    };
    private dealActiveMenu: any = (val: any) => {
        let menuArr: string[] = [];
        let activeMenu: string = "1";

        if (val.l) {
            for (let item of val.l) {
                if (item) {
                    menuArr.push(item.u);
                }
            }
        }
        
        if (this.$route.meta && this.$route.meta.parentRoute) {
            activeMenu = this.$route.meta.parentRoute;
        }

        if (
            val.u == this.$route.path ||
            val.u == activeMenu ||
            menuArr.includes(this.$route.path) ||
            menuArr.includes(activeMenu)
        )
            return true;
        return false;
    };

    get menuList() {
        return UserModule.menuList;
    }
}
